import { GENERIC_ANALYTICS_EVENTS } from 'Utilities/analytics/analyticsGenericEvents';

const categoryVerification = {
  category: 'incode_verification',
};

const categoryHandoff = {
  category: 'incode_handoff',
};

const categoryBank = {
  category: 'bank_details',
};

export const VERIFICATION_ANALYTICS_EVENTS = {
  BANK_DETAILS_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'submit and continue',
    name: 'bank_details_completed',
    url: '',
    ...categoryBank,
  }),
  BANK_DETAILS_LOAD: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    ...categoryBank,
    name: 'bank_details_upload_page',
  }),
  CONTINUE_VERIFICATION: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: 'verify your documents',
    name: 'start_verification',
    url: '/upload-documents',
    ...categoryVerification,
  }),
  DOCS_IN_REVIEW: ({ label = 'default-review' }: { label?: string }) => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: 'doc_uploaded',
    label,
    name: 'docs_in_review',
  }),
  HOW_VERIFICATION_WORKS_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: '',
    name: 'doc_verf_pop_up_closed',
    url: '/upload-documents',
    ...categoryVerification,
  }),
  HOW_VERIFICATION_WORKS_MODAL_OPEN: () => GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
    name: 'how_doc_verf_works',
    ...categoryVerification,
  }),
  INCODE_QR_MODAL_OPEN: ({ label, url }: {label: string; url: string}) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: label,
    name: 'qr_modal_opened',
    url,
    ...categoryVerification,
  }),
  LOAD_HANDOFF: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    name: 'handoff_page',
    ...categoryHandoff,
  }),
  PRIVACY_POLICY_OPEN: () => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    name: 'privacy_policy',
    ...categoryVerification,
  }),
  SOLD_DOCS_REVIEWED: () => GENERIC_ANALYTICS_EVENTS.SECTION_LOAD_EVENT({
    category: 'doc_summary',
    name: 'doc_reviewed',
  }),
  TRUSTED_PARTNER_MODAL_CLICK: () => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    button_label: '',
    name: 'trusted_provider_confirmed',
    url: '/upload-documents',
    ...categoryVerification,
  }),
  TRUSTED_PARTNER_MODAL_OPEN: () => GENERIC_ANALYTICS_EVENTS.POPUP_LOAD_EVENT({
    name: 'trusted_provider',
    ...categoryVerification,
  }),
};
